import { getTenantContext } from '@duke-hq/libctx';
import { useMemo, createContext, useContext } from 'react';

import type {
  TenantContextSettings,
  TenantContextPermissions,
} from '@duke-hq/svc-api/provider/tenantContext';

export const TenantContext =
  createContext(getTenantContext<TenantContextSettings, TenantContextPermissions>());

export function TenantContextProvider({ children }: { children: React.ReactNode }) {
  const value = useMemo(
    () => getTenantContext<TenantContextSettings, TenantContextPermissions>(),
    [],
  );
  return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>;
}

export function useTenantContext() {
  return useContext(TenantContext);
}
